/**
 * Parse portal AI triage summary text into bullet lines (aligned with patient portal
 * `parse-triage-summary` for consistent display on doctor/staff queue cards).
 */
export function parseTriageSummary(raw: string | null | undefined): string[] {
  if (!raw) return [];

  let text = raw
    .replace(/^thank you for sharing.*?[\.\!]\s*/im, '')
    .replace(/^let me (make sure|confirm|summarise|summarize).*?[\.\:]\s*/im, '')
    .replace(/^here['']?s what i (have|understand|gathered|collected).*?[\.\:]\s*/im, '')
    .replace(/^based on (what|the information).*?[\.\:]\s*/im, '');

  text = text
    .replace(/\n+is this (accurate|correct|right)\?.*$/im, '')
    .replace(/\n+does (this|that) (sound|look) (right|correct|accurate)\?.*$/im, '')
    .replace(/\n+please (let me know|confirm|check).*$/im, '')
    .replace(/\n+if (i've|i have) missed.*$/im, '')
    .replace(/\n+feel free to.*$/im, '');

  const lines = text
    .split('\n')
    .map((l) =>
      l
        .replace(/^[\s\-\*\•\–\—\d\.\)]+/, '')
        .replace(/\*\*(.*?)\*\*/g, '$1')
        .replace(/\*(.*?)\*/g, '$1')
        .trim(),
    )
    .filter((l) => l.length > 2);

  return lines;
}
